export default "__VITE_ASSET__BAnYgc85__"